import {PROFILE} from './profileActionTypes';


export function getProfileMe() {
  return {
    type: PROFILE.GET_PROFILE_ME,
    payload: {
      client: 'default',
      request: {
        url: `me`,
        method: 'get'
      }
    }
  };
}

export const removeNotificationById = (id) =>{
  return {
    type: PROFILE.PROFILE_REMOVE_NOTIFICATION,
    payload: {
      client: 'default',
      request: {
        url: `me/notifications/${id}`,
        method: 'delete',
        removeId: id
      }
    }
  }
}

export const readNotificationById = (id) =>{
  return {
    type: PROFILE.PROFILE_READ_NOTIFICATION,
    payload: {
      client: 'default',
      request: {
        url: `me/notifications/${id}/read`,
        method: 'patch',
        readId: id
      }
    }
  }
}

export const readNotificationAll = () =>{
  return {
    type: PROFILE.PROFILE_READ_ALL_NOTIFICATION,
    payload: {
      client: 'default',
      request: {
        url: `me/notifications/read`,
        method: 'post',
      }
    }
  }
}

export const readNotificationPusher = (id) =>{
  return {
    type: PROFILE.PROFILE_READ__NOTIFICATION_PUSHER,
    payload: id
  }
}
export const deleteNotificationPusher = (id) =>{
  return {
    type: PROFILE.PROFILE_DELETE_NOTIFICATION_PUSHER,
    payload: id
  }
}
export const readNotificationPusherAll = (id) =>{
  return {
    type: PROFILE.PROFILE_READ_ALL_NOTIFICATION_PUSHER_ALL}
}

export const updateNotificationCount = (type) => {
  return {
    type: PROFILE.PROFILE_UPDATE_NOTIFICATION_COUNT,
    payload: {
      type
    }
  }
}

export const addNotificationPusher = (data) => {
  return {
    type: PROFILE.ADD_NOTIFICATION_PUSHER,
    payload: data
  }
}

export function getProfileNotifications(page,withoutList = false) {
  return {
    type: PROFILE.GET_PROFILE_ME_NOTIFICATIONS,
    payload: {
      client: 'default',
      request: {
        url: `me/notifications?page=${page}&perPage=40`,
        method: 'get',
        withoutList: withoutList
      }
    }
  };
}

export function postProfileDetails(data) {
  return {
    type: PROFILE.POST_PROFILE_DETAILS,
    payload: {
      client: 'default',
      request: {
        url: `me`,
        method: 'post',
        data
      }
    }
  };
}

export function getProfileMeAvatar() {
  return {
    type: PROFILE.GET_PROFILE_ME_AVATAR,
    payload: {
      client: 'default',
      request: {
        url: `me/avatar`,
        method: 'get'
      }
    }
  };
}

export function deleteProfileMeAvatar() {
  return {
    type: PROFILE.DELETE_PROFILE_ME_AVATAR,
    payload: {
      client: 'default',
      request: {
        url: `me/avatar`,
        method: 'delete'
      }
    }
  };
}

export function postProfileMeAvatar(data) {
  return {
    type: PROFILE.POST_PROFILE_ME_AVATAR,
    payload: {
      client: 'default',
      request: {
        url: `me/avatar`,
        method: 'post',
        data
      }
    }
  };
}

export function patchProfileMeSettings(data) {
  return {
    type: PROFILE.PATCH_PROFILE_ME_SETTINGS,
    payload: {
      client: 'default',
      request: {
        url: `me/settings`,
        method: 'patch',
        data
      }
    }
  };
}

export function postProfilePassword(data) {
  return {
    type: PROFILE.POST_PROFILE_PASSWORD,
    payload: {
      client: 'default',
      request: {
        url: `me/password`,
        method: 'post',
        data
      }
    }
  };
}

export function patchProfileNotification(data) {
  return {
    type: PROFILE.PATCH_PROFILE_NOTIFICATION,
    payload: {
      client: 'default',
      request: {
        url: `me/notification-settings`,
        method: 'patch',
        data
      }
    }
  };
}

export function postProfileNotificationRead() {
  return {
    type: PROFILE.POST_PROFILE_NOTIFICATION_READ,
    payload: {
      client: 'default',
      request: {
        url: `me/notifications/read`,
        method: 'post'
      }
    }
  };
}

export function getUserRoles(type) {
  return {
    type: PROFILE.GET_USER_ROLES,
    payload: {
      client: 'default',
      request: {
        url: `auth/roles${type ? `?filter[type]=${type}` : ''}`,
        method: 'get'
      }
    }
  };
}
export function clearUserRoles() {
  return {
    type: PROFILE.CLEAR_USER_ROLES,
    payload: {}
  };
}

export function socialsProvider(provider, token) {
  return {
    type: PROFILE.GET_SOCIALS_PROVIDER,
    payload: {
      client: 'default',
      request: {
        url: `me/socials/${provider}${token}`,
        method: 'post'
      }
    }
  };
}
export function socialsProviderDelete(provider) {
  return {
    type: PROFILE.GET_SOCIALS_PROVIDER,
    payload: {
      client: 'default',
      request: {
        url: `me/socials/${provider}`,
        method: 'delete'
      }
    }
  };
}

export function editUser(id, data) {
  return {
    type: PROFILE.EDIT_USER,
    payload: {
      client: 'default',
      request: {
        url: `/users/${id}`,
        method: 'post',
        data
      }
    }
  };
}

export function changeUserPassword(id, data) {
  return {
    type: PROFILE.CHANGE_USER_PASSWORD,
    payload: {
      client: 'default',
      request: {
        url: `users/${id}/password-change`,
        method: 'post',
        data
      }
    }
  };
}

export function clearNotificationList() {
  return {
    type: PROFILE.CLEAR_NOTIFICATION_LIST,
  }
}